var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth.module"
	],
	"./chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"chat.module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login.module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile.module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"reports.module",
		"common"
	],
	"./rights/rights.module": [
		"./src/app/rights/rights.module.ts",
		"rights.module"
	],
	"./teams/teams.module": [
		"./src/app/teams/teams.module.ts",
		"teams.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main